import React from 'react';
import TrackOrder from './TrackOrder/TrackOrder';
import MyOrders from './MyOrders/MyOrders';
import { dualStoreRoute } from '../../routes/dualStoreRoute';

const OrderRoutes = ({ isTrackOrderEnabled = true, isMyOrdersEnabled = true } = {}) => (
    <>
        {isTrackOrderEnabled && dualStoreRoute('/:lang/track-order', <TrackOrder />, 'track-order')}
        {isMyOrdersEnabled && dualStoreRoute('/:lang/my-orders', <MyOrders />, 'my-orders')}
    </>
);

export default OrderRoutes;
